var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilverSeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    role: "img",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.35 83.58l.54 15.79c.01 1.19.79 1.98 2.61 1.98c1.82 0 2.62-.8 2.62-1.97l.59-17.03l-6.36 1.23z",
    fill: "#8c8c8c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M73.76 23.16H67.4l-.06 27.56l6.46-1.12z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3 5.23c-.96.14-38.72 5.7-38.72 5.7c-1.55.3-2.81 1.71-2.82 3.52l.02.78l4.19 4.94s11.95 9.65 12.84 9.48S77.32 7.36 77.32 7.36c-.58-.7-1.17-1.02-3.69-1.67c-1.19-.31-2.37-.6-3.33-.46z",
    fill: "#d9d9d9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.24 37.41l-.43-20.57c.01-1.79-.50-2.54-1.53-3.07c-1.12-.63-2.51.18-2.5 1.47l.08 19.89c0 .61-.08 2.28 1.18 2.69l2.58.74v18.55l6.36-1.24V37.41h-5.74z",
    fill: "#8c8c8c"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.03 77.09v-6.05c-2.42.3-3.58-.08-3.58-.08L30.08 58.45v3.32c0 1.45 0 2.38 2.12 3.41l.34.17l1.33 42.93c.01 1.19.91 1.98 2.72 1.98c1.82 0 2.71-.8 2.71-1.97l1.04-30.83l14.4 7.11l-.36-7.74c1.76.86 3.71.51 5.65.26z",
    fill: "#8c8c8c"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.83 64.13L58.9 72.22c-.93.21-1.6 1.04-1.60 1.99v.96c0 1.04.77 1.86 1.74 2.01c-1.64.05-3.34-.27-4.82-1.01l1.48 45.85c.01 1.19.86 1.98 2.67 1.98c1.82 0 2.69-.80 2.69-1.97l1.25-36.93l30.12-5.80l1.06 33.82c.01 1.19.89 1.98 2.70 1.98c1.82 0 2.66-.80 2.66-1.97l1.51-43.73h.01l.74-.14c1.22-.23 2.10-1.30 2.10-2.54v-3.87l-2.38 1.28z",
    fill: "#b3b3b3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M102.07 64.01l-41.83 8.01c-1.90.36-3.87.10-5.61-.77L30.81 59.43c-1.12-.56-.92-2.39.73-2.63l42.09-7.16c1.67-.32 3.43-.36 4.96.39l23.84 11.33c1.21.60.97 2.39-.36 2.65z",
    fill: "#d9d9d9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.18 7.27l-40.36 5.99c-1.75.42-2 1.81-2 2.79l.08 21.06c0 1.28 1.26 1.67 2.52 1.43l40.54-6.51c.96-.19 1.71-1.34 1.72-2.83L77.6 8.14c-.01-1.28-1.20-1.04-2.42-.87z",
    fill: "#b3b3b3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M62.3 76.68l29.87-5.72l.10 2.84l-27.43 5.25l-.74 5.70l-1.67.33z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M54.22 76.16L32.5 65.31s2.59 2.46 5 6.03c2.14 3.18 2.84 6.12 2.84 6.12l1.4.69v-5.38L54.29 79l-.07-2.84z",
    fill: "#6e6e6e"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M68.38 83.93l.19 5.73s.97-1.76 2.57-2.98c1.55-1.19 3.48-1.46 3.48-1.46l.09-2.51l-6.33 1.22z",
    fill: "#6e6e6e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverSeat);
export default __webpack_public_path__ + "static/media/silver-seat.31ce668c7dc6d142ce51b188508355aa.svg";
export { ForwardRef as ReactComponent };